<template>
  <div class="absolute w-370px z-900">
    <div
      class="alert-item-cont mt-10px mr-5px px-20px py-10px text-hex-fff rounded-6px text-14px flex max-h-270px cursor-pointer alarm-blink"
      v-for="(item, index) in alarmList"
      :key="index"
    >
      <el-tooltip
        effect="dark"
        :content="`${item.newAlarmTime}${item.alarmDescribe}`"
        placement="top"
        :open-delay="300"
      >
        <div class="flex">
          <div class="w-65px truncate">{{ item.newAlarmTime }}</div>
          <div class="w-220px truncate ml-15px">{{ item.alarmDescribe }}</div>
        </div>
      </el-tooltip>
      <div class="text-12px text-hex-feff00" @click="lookAlarm(index, item)">查看</div>
    </div>
    <AlarmDetail
      class="left-500px top-120px fixed w-800px h-500px"
      v-if="alarmDetail"
      :detailData="detailData"
      @close="alarmDetail = false"
    ></AlarmDetail>
  </div>
</template>

<script>
import { DeviceAlarmApi } from '@wiz-api/huizhou2-business'
import dayjs from 'dayjs'

const deviceAlarmApi = new DeviceAlarmApi()
const AlarmDetail = () => {
  return import('./AlarmDetail')
}
export default {
  data() {
    return {
      alarmList: [], // 报警列表
      alarmDetail: false,
      detailData: [],
      timer: null,
    }
  },
  components: { AlarmDetail },
  computed: {
    // 获取用户id
    getUserId() {
      return Wiz.AuthHooks.GetUserInfo().profile.sub || ''
    },
  },
  watch: {},
  created() {
    this.timer = setInterval(() => {
      this.getTableData()
    }, 20000)
    this.getTableData()
  },
  methods: {
    /** 获取表格数据 */
    async getTableData() {
      const [err, res] = await deviceAlarmApi.getList({
        body: { skipCount: 0, maxResultCount: 5 },
      })
      if (!err) {
        // 获取本地报警数据
        let localAlarmInfo = {}
        const info = localStorage.getItem('alarmInfo')
        if (info) {
          localAlarmInfo = JSON.parse(info)
          if (localAlarmInfo.userId === this.getUserId) {
            const list = res.items.filter((it) => {
              return !localAlarmInfo.ids.includes(it.id)
            })
            this.getData(list)
          } else {
            this.getData(res.items)
          }
        } else {
          this.getData(res.items)
        }
      }
    },
    getData(list) {
      this.alarmList = list.map((it) => {
        return {
          ...it,
          newAlarmTime: dayjs(it.alarmTime).format('HH:mm:ss'),
          alarmDescribe: `【${it.deviceName}】报警`,
        }
      })
    },
    storageData(list) {
      localStorage.setItem('alarmInfo', JSON.stringify({ ids: list, userId: this.getUserId }))
    },
    // 手动关闭某一条报警
    lookAlarm(index, item) {
      this.alarmList.splice(index, 1)
      const info = localStorage.getItem('alarmInfo')
      if (info) {
        const localAlarmInfo = JSON.parse(info)
        this.storageData([item.id, ...localAlarmInfo.ids])
      } else {
        this.storageData([item.id])
      }
      this.alarmDetail = true
      this.detailData = [
        { label: '标题', value: `【${item.deviceName}】报警` },
        { label: '设备类型', value: item.deviceTypeName },
        { label: '报警内容', value: item.alarmContent },
        { label: '报警时间', value: dayjs(item.alarmTime).format('YYYY-MM-DD HH:mm:ss') },
      ]
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>
.alert-item-cont {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
  background-image: url('../../../../assets/images/alarm-bg.png');
}

.alarm-blink {
  animation: blink-animation 0s linear infinite;
}

@keyframes blink-animation {
  0% {
    box-shadow: 0 0 0 0 #ec2a2a inset;
  }
  50% {
    box-shadow: 1px 1px 5px 4px #f31111 inset;
  }
  100% {
    box-shadow: 1px 1px 10px 8px #f80101 inset;
  }
}
</style>
